import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { navigate } from 'gatsby';
import Sticky from '~molecules/sticky';
import Button from '~atoms/button';
import { setCookie, getCookie } from '~helpers/cookies';
import styles from './cookie-consent.module.scss';

const CookieConsent = ({
  acceptText = 'Accept',
  declineText,
  declineURL = '#',
  location = 'bottom',
  children,
}) => {
  const cookieName = 'CookieConsent';
  // states
  const [ck, setCk] = useState(true);
  // when component did mount or state has updated
  useEffect(() => {
    const getCk = Boolean(getCookie(cookieName)) || false;
    setCk(getCk);
  }, [ck]);
  // when user declines
  const handleDecline = () => {
    if (declineURL !== '') navigate(`/${declineURL}`);
  };
  // when user accepts
  const handleAccept = () => {
    setCookie(cookieName, true, 365, '/');
    setCk(true);
  };

  return (
    <>
      {!ck && (
        <Sticky showOnScroll className={styles.cookieConsent} position={location}>
          <div className={styles.content}>{children}</div>

          <Button
            onClick={() => handleAccept()}
            btnText={acceptText}
            isInternalLink={false}
            isButton
            gtmClass="cookie-consent-gtm btn-cta"
          />

          {declineText && (
            <Button
              onClick={() => handleDecline()}
              btnText={declineText}
              isInternalLink={false}
              isButton
              gtmClass="cookie-consent-gtm btn-cta"
            />
          )}
        </Sticky>
      )}
    </>
  );
};

CookieConsent.propTypes = {
  acceptText: PropTypes.string,
  declineText: PropTypes.string,
  declineURL: PropTypes.string,
  location: PropTypes.oneOf(['bottom', 'top']),
  children: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.node), PropTypes.node, PropTypes.any]),
};

export default CookieConsent;
